import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      margin: 0,
      width: '100%',
      height: '3.6rem',
      padding: theme.spacing(1),

      gap: theme.spacing(1),
    },
    selectMenu: {
      paddingLeft: '1rem',
    },
    select: {
      minHeight: '3.7rem',
      minWidth: '30rem',
      background: theme.palette.background.default,
      borderRadius: 5,
      color: theme.palette.secondary.main,

      '&.Mui-disabled': {
        color: theme.palette.secondary.main,
      },
    },
    menuList: {
      maxHeight: '28rem',
    },
    listOfLayers: {
      width: '30rem',
      gap: theme.spacing(1.5),
      fontSize: '1.4rem',
      borderBottom: '1px solid #CECFCE',
      paddingBottom: '0.5rem',

      '& > span': {
        lineHeight: 0,
        fontWeight: 500,

        '&:nth-child(3)': {
          flex: 1,
          textAlign: 'center',
        },
      },
    },
  }),
)
